type IPriceDTO = {
  consumer: string | null
  currency_code: string | null
  customer: string | null
  list: string | null
  lowest_sale: string | null
  price_per_price_uom?: string | null
  price_uom: string | null
  price_uom_lowest_sale: string | null
  price_uom_sale: string | null
  sale: string | null
  type: string | null
  uom: string | null
}
export type IPricePerProduct = Record<string, IPriceDTO>

export class PriceDTO {
  consumer: string | null
  currencyCode: string | null
  customer: string | null
  list: string | null
  lowestSale: string | null
  pricePerPriceUom: string | null
  priceUom: string | null
  priceUomLowestSale: string | null
  priceUomSale: string | null
  sale: string | null
  type: string | null
  uom: string | null

  constructor(data: IPriceDTO) {
    this.consumer = data.consumer
    this.currencyCode = data.currency_code
    this.customer = data.customer
    this.list = data.list
    this.lowestSale = data.lowest_sale
    this.pricePerPriceUom = data.price_per_price_uom ?? null
    this.priceUom = data.price_uom
    this.priceUomLowestSale = data.price_uom_lowest_sale
    this.priceUomSale = data.price_uom_sale
    this.sale = data.sale
    this.type = data.type
    this.uom = data.uom
  }
}

export type PricePerProduct = Record<string, PriceDTO>

export class PriceError {
  constructor(
    public status: number,
    public json: any,
  ) {
  }
}

export const createPriceDTO = (data?: Partial<IPriceDTO>): IPriceDTO =>
  Object.assign({}, {
    consumer: null,
    currency_code: null,
    customer: null,
    list: null,
    lowest_sale: null,
    price_per_price_uom: null,
    price_uom: null,
    price_uom_lowest_sale: null,
    price_uom_sale: null,
    sale: null,
    type: null,
    uom: null,
  }, data)
